import * as Bowser from 'bowser';
import { GECKO_WINDOW_PROPERTY, ParserDeviceTypes, ParserOSNames, WEBKIT_NAVIGATOR_VENDOR, } from './getClientData.constants';
export const getClientData = () => {
    const clientData = Bowser.parse(window.navigator.userAgent);
    return {
        browserName: clientData.browser.name,
        isAndroid: clientData.os.name === ParserOSNames.Android,
        isGecko: GECKO_WINDOW_PROPERTY in window,
        isMacOS: clientData.os.name === ParserOSNames.MacOS,
        isWindows: clientData.os.name === ParserOSNames.Windows,
        isLinux: clientData.os.name === ParserOSNames.Linux,
        isIos: clientData.os.name === ParserOSNames.IOS,
        isMobile: clientData.platform.type === ParserDeviceTypes.Mobile,
        isWebKit: window.navigator.vendor === WEBKIT_NAVIGATOR_VENDOR,
        osName: clientData.os.name,
        /**
         * https://lucidlink.atlassian.net/browse/LUCID-24912
         * Bowser returns frozen macOS version (10.15.7) from User-Agent.
         * Browsers intentionally freeze this for privacy. Actual version may differ.
         */
        platformVersion: clientData.os.version,
    };
};
